import { defineComponent, h, type Component } from 'vue'
import { Archive, Check, Info, TriangleAlert, X } from 'lucide-vue-next'

// The Toaster's icons (App.vue): the tone lives in a round chip, the card stays white for every tone, so a stack
// never turns into a wall of colour. One shape per tone, the bright fill only on the icon.
function chip(icon: Component, tint: string, ink: string) {
  return defineComponent({
    name: 'ToastIcon',
    setup: () => () => h('span', { class: `toast-chip ${tint}`, 'aria-hidden': 'true' }, [h(icon, { size: 16, strokeWidth: 2.25, class: ink })]),
  })
}

// An exclamation mark without a circle: the chip is the circle.
const Bang = defineComponent({
  name: 'Bang',
  setup: () => () => h('svg', {
    width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': 2.25,
    'stroke-linecap': 'round', class: 'text-error',
  }, [h('path', { d: 'M12 7v6' }), h('path', { d: 'M12 17h.01' })]),
})

export const TOAST_ICONS = {
  success: chip(Check, 'bg-success-bg', 'text-success'),
  error: defineComponent({
    name: 'ToastIcon',
    setup: () => () => h('span', { class: 'toast-chip bg-error-bg', 'aria-hidden': 'true' }, [h(Bang)]),
  }),
  warning: chip(TriangleAlert, 'bg-warning-bg', 'text-warning'),
  info: chip(Info, 'bg-info-bg', 'text-info'),
  close: defineComponent({ name: 'ToastClose', setup: () => () => h(X, { size: 16 }) }),
}

/** The neutral chip for a plain toast, e.g. "Moved to photo storage" (passed as the toast's `icon`). */
export const StorageIcon = chip(Archive, 'bg-canvas', 'text-muted')
